import React, { useRef, useState } from "react";
import DatePicker from "../FormComponents/DatePicker";
// import SignatureCanvas from "react-signature-canvas";
import { TextField, FormHelperText } from "@material-ui/core";
import { getIn } from "formik";
import { Number } from "../../utils/Number";
import { TextMaskCustom } from "../../utils/TextMaskCustom";
import IconButton from "@material-ui/core/IconButton";
import ClearOutlinedIcon from "@material-ui/icons/ClearOutlined";
import Tooltip from "@material-ui/core/Tooltip";
import Popover from "@material-ui/core/Popover";
import InfoIcon from "@material-ui/icons/Info";
import { makeStyles } from "@material-ui/core/styles";
import AutoCompleteRelations from "../FormComponents/AutoCompleteRelations";
import CreateIcon from "@material-ui/icons/Create";
import Signature from "../Signature";

const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: theme.spacing(1),
  },
  imageFluid: {
    color: "rgba(0, 0, 0, 0.87)",
    width: "initial",
    // maxHeight: '100px',
    // minHeight: '100px',
    height: "100px",
    opacity: "1",
    display: "block",
    maxWidth: "100%",
    boxSizing: "border-box",
    transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
    borderRadius: "4px",
  },
}));

const authorizationInfo = [
  {
    label: "Name",
    name: "authorization.name",
    type: "text",
    required: true,
  },
  {
    label: "Relationship to the Patient",
    name: "authorization.relationship",
    type: "autoComplete",
    required: true,
  },

  {
    label: "Date",
    name: "authorization.date",
    type: "datePicker",
    required: true,
    hideIcon: true,
  },
  {
    label: "Phone",
    name: "authorization.phone",
    type: "phone",
    required: true,
  },
  // {
  //   label: "Signature",
  //   name: "authorization.signature",
  //   type: "signature",
  //   required: true,
  // },
];
const Authorization = ({
  values,
  touched,
  error,
  handleChange,
  errors,
  setFieldValue,
}) => {
  const classes = useStyles();
  const sigPad = useRef({});

  const [otherField, setOtherField] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isSignatureModalOpen, openSignatureModal] = useState(true);

  const clear = () => {
    sigPad.current.clear();
    setFieldValue("authorization.signature", "");
  };

  return (
    <div className="card custom-card">
      <div className="authorization">
        <div className="title">
          <h5>AUTHORIZATION </h5>
          <p className="first-para">
            Your signature on this form indicates that you are giving permission
            for the uses and disclosures of protected health information to the
            payers described herein. You understand that this authorization will
            automatically expire one year from the date authorized.
          </p>
          <p className="second-para">
            In the event you wish to revoke the authorization prior to that
            time, please contact our office at (888) 383-8025 or by email at{" "}
            <span className="font-italic">
              <a href="mailto:CompleteBillingServices.biz">
                Contact@CompleteBillingServices.biz
              </a>
            </span>
            .
          </p>
        </div>
        <div className="row">
          {authorizationInfo.map(
            (
              { label, name, type, required = false, hideIcon = false },
              ind
            ) => {
              let obj = {
                a: `${name}`.split(".")[0],
                b: `${name}`.split(".")[1],
              };
              if (type === "text") {
                return (
                  <div className="form-group col-md-6  col-lg-4" key={ind}>
                    <TextField
                      label={label}
                      name={name}
                      onChange={handleChange}
                      fullWidth
                      value={values[name]}
                      aria-label="text-field"
                      error={Boolean(
                        getIn(touched, name) && getIn(errors, name)
                      )}
                      helperText={
                        getIn(touched, name) &&
                        getIn(errors, name) &&
                        getIn(errors, name)
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      // margin="dense"
                      required={required}
                      inputProps={{
                        maxLength: name === "authorization.name" ? 50 : 35,
                      }}
                    ></TextField>
                  </div>
                );
              } else if (type === "phone") {
                return (
                  <div
                    className="form-group col-md-6 col-lg-4 signMarginTop"
                    key={ind}
                  >
                    <TextField
                      label={label}
                      name={name}
                      onChange={handleChange}
                      fullWidth
                      value={values[name]}
                      aria-label="text-field"
                      error={Boolean(
                        getIn(touched, name) && getIn(errors, name)
                      )}
                      helperText={
                        getIn(touched, name) &&
                        getIn(errors, name) &&
                        getIn(errors, name)
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        inputComponent:
                          type === "phone" ? TextMaskCustom : Number,
                      }}
                      // margin="dense"
                      required={required}
                    ></TextField>
                  </div>
                );
              } else if (type === "autoComplete") {
                return (
                  <div className="form-group col-md-6 col-lg-8" key={ind}>
                    <div className="row">
                      <div className="form-group col-md-12 col-lg-6" key={ind}>
                        <AutoCompleteRelations
                          label={label}
                          name={name}
                          onChange={(e, value) => {
                            if (value) {
                              setFieldValue(`${name}`, value.value);
                              if (value.label === "Other") {
                                setOtherField(true);
                              } else {
                                setOtherField(false);
                              }
                            } else {
                              setFieldValue(`${name}`, "");
                            }
                          }}
                          value={values[name]}
                          aria-label="auto-complete"
                          fullWidth
                          error={Boolean(
                            getIn(touched, name) && getIn(errors, name)
                          )}
                          helperText={
                            getIn(touched, name) &&
                            getIn(errors, name) &&
                            getIn(errors, name)
                          }
                          required={required}
                        />
                      </div>
                      {otherField ? (
                        <div
                          className="form-group col-md-6  col-lg-6"
                          key={ind + name}
                        >
                          {console.log(values.authorization)}
                          <TextField
                            label="Please specify relationship"
                            name={"authorization.relationship"}
                            onChange={handleChange}
                            fullWidth
                            value={values.authorization.relationship}
                            aria-label="text-field"
                            error={Boolean(
                              getIn(touched, "authorization.relationship") &&
                                getIn(errors, "authorization.relationship")
                            )}
                            helperText={
                              getIn(touched, "authorization.relationship") &&
                              getIn(errors, "authorization.relationship") &&
                              getIn(errors, "authorization.relationship")
                            }
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{ maxLength: 35 }}
                            // margin="dense"
                            required={required}
                          ></TextField>
                        </div>
                      ) : null}
                    </div>
                  </div>
                );
              } else if (type === "datePicker") {
                return (
                  <div
                    className="form-group col-md-6 col-lg-4 signMarginTop"
                    key={name + ind}
                  >
                    <DatePicker
                      name={name}
                      autoOk
                      label={label}
                      format="DD/MM/yyyy"
                      value={values[obj.a][obj.b]}
                      onChange={(val) => {
                        setFieldValue(name, val);
                      }}
                      error={Boolean(
                        getIn(touched, name) && getIn(errors, name)
                      )}
                      helperText={
                        getIn(touched, name) &&
                        getIn(errors, name) &&
                        getIn(errors, name)
                      }
                      required={required}
                      disabled={true}
                      hideIcon={hideIcon}
                    />
                    <FormHelperText>
                      {Boolean(getIn(touched, name) && getIn(errors, name)) && (
                        <span style={{ color: "red", fontSize: "0.75rem" }}>
                          {getIn(errors, name)}
                        </span>
                      )}{" "}
                    </FormHelperText>
                  </div>
                );
              } else if (type === "signature") {
                return (
                  <div className="form-group col-md-6 col-lg-6">
                    <div className="row">
                      <div
                        className="form-group col-lg-10 align-items-center signature"
                        key={name + ind}
                      >
                        <div
                          style={{
                            borderBottom:
                              getIn(errors, "authorization.signature") &&
                              getIn(touched, "authorization.signature")
                                ? "2px solid red"
                                : "1px solid black",
                          }}
                        >
                          <h6>
                            Signature
                            {Boolean(
                              getIn(touched, "authorization.signature") &&
                                getIn(errors, "authorization.signature")
                            ) ? (
                              <span style={{ color: "red" }}>*</span>
                            ) : (
                              "*"
                            )}
                            <div className="MuiButtonBase-root MuiIconButton-root MuiIconButton-colorPrimary">
                              <CreateIcon
                                style={{ color: "#0365A5" }}
                                onClick={() => openSignatureModal(true)}
                              />
                            </div>
                          </h6>

                          <img
                            onClick={() => openSignatureModal(true)}
                            src={values.authorization.signature}
                            className={`mx-auto ${classes.imageFluid}`}
                          />
                        </div>
                        <FormHelperText>
                          {Boolean(
                            getIn(touched, "authorization.signature") &&
                              getIn(errors, "authorization.signature")
                          ) && (
                            <span style={{ color: "red" }}>
                              {getIn(errors, "authorization.signature")}
                            </span>
                          )}{" "}
                        </FormHelperText>
                      </div>
                    </div>
                  </div>
                );
              }
            }
          )}
        </div>
      </div>
      {isSignatureModalOpen && (
        <Signature
          isSignatureModalOpen={isSignatureModalOpen}
          openSignatureModal={openSignatureModal}
          values={values}
          touched={touched}
          error={error}
          handleChange={handleChange}
          errors={errors}
          setFieldValue={setFieldValue}
        />
      )}
    </div>
  );
};

export default Authorization;
